import axios from "axios";

export const getBarqTrackingAPI = (orderId: string) => {
  return axios.get(
    `${process.env.REACT_APP_ORDERING_ENDPOINT}/api/dms/barq/orders/${orderId}/tracking`,
  );
};
